// v2 campaign catalog lane — owned by the same agent as app/v2/slot3.tsx. Do not edit
// from another lane. One entry per shipped v2 page.
import type { V2CatalogEntry } from './types';

export const slot3Catalog: V2CatalogEntry[] = [
  {
    rank: 2,
    title: 'Receipt Maintenance',
    route: '/receipts/maintenance2',
    // Route TEMPLATE — w_receipt_maint's PH10 route is param-keyed. The bare
    // /receipts/maintenance prefix (the faithful page's own lookup card) is what a click
    // lands on; the params are shown so the row names the real faithful route.
    faithfulRoute: '/receipts/maintenance/:po/:releaseNum',
    score: 20,
    blurb:
      'Received-vs-expected hero meter, the Ordered→Posted pipeline and derived alerts up front, with the 38-icon toolbar re-cast as a Pre-receive→Bill ladder that says why each action is greyed.',
  },
  {
    rank: 11,
    title: 'Receive Product',
    route: '/receipts/receive-product2',
    faithfulRoute: '/receipts/receive-product',
    score: 18,
    blurb:
      'The scan field owns the screen: a permanent receipt-progress + tolerance-watch header, a big "last scanned" confirmation card, and a previewed Receive All — settings, timer and line detail move to the rail.',
  },
  {
    rank: 37,
    title: 'Recv Putaway Sort by Zone',
    route: '/putaway-sort/rcv-by-zone2',
    faithfulRoute: '/putaway-sort/rcv-by-zone',
    score: 17,
    blurb:
      'A station header that answers "where am I in this receipt" and "how full are my totes", with Undo and Close Receipt labelled by their consequence instead of by their icon.',
  },
  {
    rank: 33,
    title: 'Trailer Search',
    route: '/yard/trailer-search2',
    faithfulRoute: '/yard/trailer-search',
    score: 17,
    blurb:
      'A yard status board instead of a search form: On site / At a door / Loaded / Awaiting arrival plus the longest-dwell number PB never computes, a ">24h on site" alert, and Check in / Assign door / Release named in yard language.',
  },
  {
    rank: 38,
    title: 'Inbound Truck Search',
    route: '/yard/inbound-trucks2',
    faithfulRoute: '/browse/inbound-trucks',
    score: 17,
    blurb:
      'A dock queue keyed on dockyard_status — Expected today / Arrived-not-doored / At a door / Late, a door-occupancy list with dwell, and named cross-links to the receipt the truck is carrying and to its trailer.',
  },
  {
    rank: 31,
    title: 'Auto Restock',
    route: '/restock/auto-restock2',
    faithfulRoute: '/restock/auto-restock',
    score: 17,
    blurb:
      'A per-row onhand-vs-min/optimal/max gauge with a stock-health strip (At zero / Below min / pieces suggested / where the shortage sits), a rail by urgency instead of by criteria, and a two-step Generate that says "N requests, M pieces, across K zones" — with every skipped row named — before it writes.',
  },
  {
    rank: 32,
    title: 'Putaway Errors',
    route: '/putaway-errors2',
    faithfulRoute: '/putaway-errors',
    score: 17,
    blurb:
      'The queue grouped by the free-text calc_message nobody aggregates — "3 × No location found for rule STD-PA" leading the page — a rail of By reason / By putaway rule / By owner-item, and a one-gesture bulk requeue that stages the same two fields PB\'s ue_update persists, CPD quirk stated up front.',
  },
  {
    rank: 36,
    title: 'Restock Requests',
    route: '/restock/requests2',
    faithfulRoute: '/browse/rstk-requests',
    score: 17,
    blurb:
      'A queue-health strip over the embedded browse\'s own rows — open requests, requests in Error, the usr_qty still pending, the oldest — a calc_code composition in the registry\'s verbatim words, and "Set priority → N for this whole group" through the grid\'s own save path.',
  },
  {
    // slice-3689. NOT from the v2_wins.html survey — Chris asked for it directly
    // (docs/demochanges.txt 2026-09-17: the demo "New Screens" slider swaps seven screens for
    // their v2, and Location Search had none — "please go ahead and create it"). Ranked 51 so
    // it sorts after the survey's 50 without renumbering anything; the score is this lane's
    // own read against the survey's rubric, not a survey figure.
    rank: 52,
    title: 'Location Search',
    route: '/browse/cfg-locations2',
    faithfulRoute: '/browse/cfg-locations',
    score: 17,
    blurb:
      'The shape of the result set before the rows — found / blocked / occupied / empty-and-usable with an occupancy meter PB never computes — a rail of the questions a slotter asks (plus By area and By location type) over ONE retrieve, and the eight-icon toolbar as an Inspect→Act→Create ladder in which every drill carries the focused row\'s own warehouse.',
  },
];
